import React from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as ElectricCabin } from '../../../resources/images/wagon-icons/electricCabin.svg';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonElectricCabin({ style = {} }) {
  const { trans } = useTranslation();

  // They asked me to remove this Icon, but they might ask for it later
  // just remove false && and it will work
  return false && (
    <div className="wagon-feature" style={style}>
      <Tooltip title={trans('electric_locker')}>
        <ElectricCabin />
      </Tooltip>
    </div>
  );
}

export default WagonElectricCabin;
